import { types } from "../types/types";

export const getCompanyList = (values) => ({
  type: types.getCompanyList,
  payload: values,
});

export const importCompanyList = (companiesByUser) => {
  return async (dispatch) => {
    try {
      dispatch(getCompanyList(companiesByUser));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getSelectedCompany = (values) => ({
  type: types.selectedCompany,
  payload: values,
});

export const importSelectedCompany = (company) => {
  return async (dispatch) => {
    try {
      dispatch(getSelectedCompany(company));
    } catch (e) {
      console.error(e);
    }
  };
};

export const getLoadingState = (values) => ({
  type: types.getLoadingState,
  payload: values,
});

export const importLoadingState = (loading) => {
  return async (dispatch) => {
    try {
      dispatch(getLoadingState(loading));
    } catch (e) {
      console.error(e);
    }
  };
};

export const getUpdateCompanyNeeded = (values) => ({
  type: types.getUpdateCompanyNeeded,
  payload: values,
});

export const importUpdateCompanyNeeded = (values) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdateCompanyNeeded(values));
    } catch (error) {
      console.error(error);
    }
  };
};